/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findById } from '../fn/user-controller/find-by-id';
import { FindById$Params } from '../fn/user-controller/find-by-id';
import { getGeolocConsent } from '../fn/user-controller/get-geoloc-consent';
import { GetGeolocConsent$Params } from '../fn/user-controller/get-geoloc-consent';
import { login } from '../fn/user-controller/login';
import { Login$Params } from '../fn/user-controller/login';
import { LoginResponse } from '../models/login-response';
import { updateGeolocConsents } from '../fn/user-controller/update-geoloc-consents';
import { UpdateGeolocConsents$Params } from '../fn/user-controller/update-geoloc-consents';
import { UserGeolocationConsentResponse } from '../models/user-geolocation-consent-response';
import { UserType } from '../models/user-type';

@Injectable({ providedIn: 'root' })
export class UserControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateGeolocConsents()` */
  static readonly UpdateGeolocConsentsPath = '/v2/users/consents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGeolocConsents()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGeolocConsents$Response(
    params: UpdateGeolocConsents$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return updateGeolocConsents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGeolocConsents$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGeolocConsents(params: UpdateGeolocConsents$Params, context?: HttpContext): Observable<{}> {
    return this.updateGeolocConsents$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `login()` */
  static readonly LoginPath = '/v2/users/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login$Response(params: Login$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginResponse>> {
    return login(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login(params: Login$Params, context?: HttpContext): Observable<LoginResponse> {
    return this.login$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginResponse>): LoginResponse => r.body)
    );
  }

  /** Path part for operation `findById()` */
  static readonly FindByIdPath = '/v2/users/{id_user}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: FindById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserType>> {
    return findById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: FindById$Params, context?: HttpContext): Observable<UserType> {
    return this.findById$Response(params, context).pipe(map((r: StrictHttpResponse<UserType>): UserType => r.body));
  }

  /** Path part for operation `getGeolocConsent()` */
  static readonly GetGeolocConsentPath = '/v2/users/consent/{id_user}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGeolocConsent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeolocConsent$Response(
    params: GetGeolocConsent$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<UserGeolocationConsentResponse>> {
    return getGeolocConsent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGeolocConsent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeolocConsent(params: GetGeolocConsent$Params, context?: HttpContext): Observable<UserGeolocationConsentResponse> {
    return this.getGeolocConsent$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserGeolocationConsentResponse>): UserGeolocationConsentResponse => r.body)
    );
  }
}
